module.exports = __webpack_public_path__ + "static/media/notes.31fd3989.png";